import React from 'react';
import PropTypes from 'prop-types';
import Bundle from '@saucelabs/sl-component-bundle';
import { Route, Switch } from 'react-router-dom';
import { InExperimentContainer } from '@saucelabs/sl-container-experiment';
import dynamic from '@redux-dynostore/react-redux';
import { attachReducer } from '@redux-dynostore/core';
import { SentryBoundary } from '@saucelabs/sl-component-sentry';
import { constants as sentryConstants } from '@saucelabs/sl-util-sentry';
import { LoginRequiredContainer } from '@saucelabs/sl-container-authentication';

import OrgAdminContainer from './containers/OrgAdminContainer';
import WelcomeBilling from './containers/WelcomeBilling';
import billingReducer from './reducers';

const importInvoicesBilling = () => import(/* webpackChunkName: "billingInvoice" */ './containers/InvoicesContainer');

const UnifiedBilling = ({ match }) => (
  <LoginRequiredContainer>
    <InExperimentContainer name="web-ui-unified-billing">
      <SentryBoundary owner={sentryConstants.TEAMS.WEB_PLATFORM}>
        <OrgAdminContainer>
          <Switch>
            <Route
              exact
              path={`${match.url}`}
              render={() => (<WelcomeBilling />)}
            />
            <Route
              path={`${match.url}/invoices`}
              render={(props) => (
                <Bundle load={importInvoicesBilling}>
                  {(Component) => (
                    <Component
                      activeTab={match.url}
                      {...props}
                    />
                  )}
                </Bundle>
              )}
            />
          </Switch>
        </OrgAdminContainer>
      </SentryBoundary>
    </InExperimentContainer>
  </LoginRequiredContainer>
);

UnifiedBilling.propTypes = {
  match: PropTypes.object.isRequired,
};

export default dynamic(
  'apps.billing', attachReducer(billingReducer),
)(UnifiedBilling);
